import { useQuery } from '@tanstack/react-query';
import { BotAPIClient } from '@/api/client';
import { useRef } from 'react';
export function useSkipSummary(version, enabled = true) {
    const clientRef = useRef(null);
    if (!clientRef.current || clientRef.current.getVersion() !== version) {
        clientRef.current = new BotAPIClient(version);
    }
    return useQuery({
        queryKey: ['skipSummary', version],
        queryFn: async () => {
            const response = await clientRef.current.getSkipSummary();
            if ('error' in response) {
                throw new Error(response.error);
            }
            return response;
        },
        enabled,
        staleTime: 60000,
        refetchInterval: 60000,
        placeholderData: (prev) => prev,
    });
}
//# sourceMappingURL=useSkipSummary.js.map